/* eslint-disable max-lines-per-function */
import React, { useState } from "react";
import { DatePicker } from "@mui/x-date-pickers";
import { Button } from "components/haven-design/buttons";
import { Modal } from "components/haven-design/modal";
import { DialogActions, DialogContent } from "components/haven-design/modal/dialog";

type Props = {
  interestName?: string;
  interestCount?: number;
  onSubmit: (deadline: Date) => void;
  onCancel: () => void;
  onRequestClose: () => void;
  isOpen: boolean;
}

const SendFullAppModal: React.FC<Props> = (props) => {
  const {
    onSubmit,
    onCancel,
    onRequestClose,
    interestName,
    interestCount,
    isOpen,
  } = props;

  const defaultDeadline = new Date();
  defaultDeadline.setDate(defaultDeadline.getDate() + 14);

  const [deadline, setDeadline] = useState<Date | null>(defaultDeadline);

  const title = interestName ? (
    `Send Full Application to ${interestName}`) : (
    `Send Full Application to ${interestCount} Applicants`);

  return (
    <>
      <Modal
        title={title}
        isOpen={isOpen}
        onRequestClose={onRequestClose}
        fullWidth={false}
      >
        <DialogContent>
          <DatePicker
            slotProps={{
              textField: {
                fullWidth: true,
                margin: "dense",
                label: "Deadline",
                variant: "outlined",
                autoComplete: "off",
              },
              inputAdornment: { position: "end" },
            }}
            minDate={new Date()}
            format="MM/dd/yyyy"
            closeOnSelect
            onChange={(date: Date | null) => setDeadline(date)}
            value={deadline}
          />
        </DialogContent>
        <DialogActions>
          <Button
            color="secondary"
            size="S"
            onClick={onCancel}
          >
            Cancel
          </Button>
          <Button
            color="primary"
            size="S"
            disabled={!deadline || isNaN(deadline.getTime())}
            onClick={() => deadline && onSubmit(deadline)}
          >
            Confirm
          </Button>
        </DialogActions>
      </Modal>
    </>
  );
};

export default SendFullAppModal;
